import React, { memo, RefObject } from 'react';
import styled from 'styled-components';
import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { WidgetHeader } from './widgetHeader';
import { CSSObject } from 'styled-components';
import { WidgetHeaderTextType } from '../types';

const defaultCustomIconStyle = { 
    transform: 'rotate(-90deg)' 
};

interface MediaWidgetViewProps {
    routeToPage: string;
    widgetHeaderText: WidgetHeaderTextType;
    showArrowIcon: boolean;
    bodyChildren: React.ReactNode;
    isErrorView?: boolean;
    customIconStyle?: CSSObject;
    widgetRef?: RefObject<HTMLAnchorElement> | null;
    enableTrafficCamerasPageOnWeb2?: boolean;
    enableWeatherCamerasPageOnWeb2?: boolean;
    enableFireAlertsPageOnWeb2?: boolean;
}

// eslint-disable-next-line react/display-name
export const MediaWidgetView = memo(({
    isErrorView = false,
    routeToPage,
    widgetHeaderText,
    bodyChildren,
    showArrowIcon,
    widgetRef,
    customIconStyle=defaultCustomIconStyle,
    enableTrafficCamerasPageOnWeb2,
    enableWeatherCamerasPageOnWeb2,
    enableFireAlertsPageOnWeb2
}: MediaWidgetViewProps) => {
    
    if (enableTrafficCamerasPageOnWeb2 || enableWeatherCamerasPageOnWeb2 || enableFireAlertsPageOnWeb2) {
        return (
            <WidgetWrapper ref={widgetRef} href={routeToPage} target='_self' >
                <Container noData={isErrorView}>
                    <WidgetHeader 
                        headerText={widgetHeaderText}
                        iconStyle={customIconStyle}
                        showArrowIcon={showArrowIcon} />
                    <WidgetBody>
                        {bodyChildren}
                    </WidgetBody>
                </Container>
            </WidgetWrapper>
        );
    }
    return (
        <WidgetWrapper ref={widgetRef} href={routeToPage}>
            <Container noData={isErrorView}>
                <WidgetHeader 
                    headerText={widgetHeaderText}
                    iconStyle={customIconStyle}
                    showArrowIcon={showArrowIcon} />
                <WidgetBody>
                    {bodyChildren}
                </WidgetBody>
            </Container>
        </WidgetWrapper>
    );
});

interface ContainerProps {
    noData: boolean;
}

const Container = styled.div<ContainerProps>`
    height: 250px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: ${({ noData }) => noData ? 'center' : 'flex-start'};
    background-color: #F9F9F9;
    color: #000000;
    cursor: pointer;
    border-radius: 2px;

    @media ${smallMediaQuery} {
        height: 170px;
    };
`;

const WidgetBody = styled.div`
    display: flex;
    height: 213px;
    @media ${smallMediaQuery} {
        height: 133px;
    };
`;

const WidgetWrapper = styled.a`
    display: flex;
    width: 100%;
    height: 100%;
    text-decoration: none;
`;
